import React, { useEffect, useState } from "react";
import "./RawWebhook.css";
import { getRawWebhooks } from "../../../config/LiveApi";
import Pagination from "../pagination";
import { toast } from "react-toastify";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import { IoMdCopy } from "react-icons/io";

const RawWebhookPage = () => {
  const [statusData, setStatusData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedRows, setExpandedRows] = useState(new Set());

  const fetchRawWebhookData = async (currentPage, searchTerm) => {
    try {
      setLoading(true);
      const response = await getRawWebhooks(
        currentPage,
        searchTerm,
        searchTerm
      );
      setStatusData(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Unable to fetch status.");
    }
  };

  const toggleRow = (key) => {
    setExpandedRows((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(key)) {
        newSet.delete(key);
      } else {
        newSet.add(key);
      }
      return newSet;
    });
  };

  useEffect(() => {
    if (searchTerm !== "") {
      const delayDebounce = setTimeout(() => {
        fetchRawWebhookData(1, searchTerm);
      }, 1000);
      return () => clearTimeout(delayDebounce);
    }
  }, [searchTerm]);

  useEffect(() => {
    if (searchTerm === "") {
      fetchRawWebhookData(currentPage, "");
    }
  }, [currentPage, searchTerm]);

  const handleCopy = (data) => {
  const text = JSON.stringify(data, null, 2);
  navigator.clipboard.writeText(text)
    .then(() => {
      alert("Response Copied!");
    })
    .catch((err) => {
      console.error("Copy failed", err);
    });
};


  return (
    <div className="raw-webhook-table-container">
      <div className="raw-webhook-heading">
        <h2 className="raw-webhook-table-title">Raw Webhooks</h2>
        <input
          className="webhook-input-field-container"
          type="text"
          placeholder="Search by Order ID or Transaction ID"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <table className="webhook-table">
        <thead>
          <tr>
            <th>OrderId</th>
            <th>Transaction Id</th>
            <th>Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="6">Loading...</td>
            </tr>
          ) : statusData?.length > 0 ? (
            statusData.map((group, index) => {
              const groupItems = Array.isArray(group) ? group : [group];
              const firstItem = groupItems[0];
              const rowKey = `${firstItem.orderId}-${firstItem.transactionId}`;

              return (
                <React.Fragment key={rowKey}>
                  <tr>
                    <td>{firstItem?.orderId || "N/A"}</td>
                    <td>{firstItem?.transactionId || "N/A"}</td>
                    <td>
                      {new Date(firstItem?.updatedAt).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: false,
                      })}
                    </td>
                    <td
                      onClick={() => toggleRow(rowKey)}
                      style={{ cursor: "pointer" }}
                    >
                      {expandedRows.has(rowKey) ? (
                        <FaCaretUp />
                      ) : (
                        <FaCaretDown />
                      )}
                    </td>
                  </tr>

                  {expandedRows.has(rowKey) && (
                    <tr>
                      <td colSpan="7">
                        <div className="flex-column">
                          {groupItems.map((item, subIndex) => (
                            <div
                              key={subIndex}
                              className="group-item"
                              style={{
                                marginBottom: "16px",
                                paddingBottom: "16px",
                                borderBottom: "2px solid black",
                              }}
                            >
                              <div className="details-grid">
                                <div className="more-details">
                                  <p className="json-card">OrderId :</p>
                                  <p>{item.orderId}</p>
                                </div>
                                <div className="more-details">
                                  <p className="json-card">TransactionId :</p>
                                  <p>{item.transactionId}</p>
                                </div>
                                <div className="more-details">
                                  <p className="json-card">Date :</p>
                                  <p>
                                    {new Date(item?.updatedAt).toLocaleString(
                                      "en-GB",
                                      {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        second: "2-digit",
                                        hour12: false,
                                      }
                                    )}
                                  </p>
                                </div>
                                 <div className="more-details">
                                  <p className="json-card">Status :</p>
                                  <p className="color">{item?.mapWebhook.RESPONSE_STATUS || "N/A"}</p>
                                </div>
                              </div>
                              <div className="flex-column">
                                <div className="more-details">
                                  <div className="copy-container">
                                  <p className="json-card">
                                    Incoming Webhook :
                                  </p>
                                  <p className="json-card" onClick={() => handleCopy(item?.rawWebhook)}>
                                   <IoMdCopy size={20}/>
                                  </p>
                                  </div>
                                  <span>
                                    {JSON.stringify(item?.rawWebhook, null, 2)}
                                  </span>
                                </div>
                                <div className="more-details">
                                  <div className="copy-container">
                                  <p className="json-card">
                                    Outgoing Webhook :
                                  </p>
                                  <p className="json-card" onClick={() => handleCopy(item?.mapWebhook)}>
                                   <IoMdCopy size={20}/>
                                  </p>
                                  </div>
                                  <span>
                                    {JSON.stringify(item?.mapWebhook, null, 2)}
                                  </span>
                                </div>
                                <div className="more-details">
                                  <p className="json-card">Meta Data :</p>
                                  <span>
                                    {JSON.stringify(item?.metaData, null, 2)}
                                  </span>
                                </div>
                              </div>
                              <hr />
                            </div>
                          ))}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })
          ) : (
            <tr>
              <td colSpan="7">No data found.</td>
            </tr>
          )}
        </tbody>
      </table>
      <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} />
    </div>
  );
};

export default RawWebhookPage;
